import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { SofaLoader, generateDispatchToPropsMap } from '@sofology/sofologycomponents';
import AdyenCheckout from '@adyen/adyen-web';
import { OnPaymentCompletedData } from '@adyen/adyen-web/dist/types/components/types';
import { CoreOptions } from '@adyen/adyen-web/dist/types/core/types';
import '@adyen/adyen-web/dist/adyen.css';

import './CardPayment.scss';

import { AppState } from 'store';
import { PaymentSessionModel } from 'models/Payment';
import { appConfig } from 'configurations';
import { CardPaymentCompleteFunc, CardPaymentRejectFunc, CreatePaymentSessionFunc, cardPaymentComplete, cardPaymentReject, createPaymentSession, ValidateBeforePaymentFunc, validateBeforePayment } from 'store/payment/actions';
import { paymentHelper, scrollHelper } from 'helpers';

interface OwnProps {
}

interface StateProps {
    paymentSession: PaymentSessionModel | null;
    isPaymentSessionLoading: boolean;
}

interface DispatchProps {
    createPaymentSession: CreatePaymentSessionFunc;
    cardPaymentReject: CardPaymentRejectFunc;
    cardPaymentComplete: CardPaymentCompleteFunc;
    validateBeforePayment: ValidateBeforePaymentFunc;
}

interface OwnState {
}

class CardPayment extends Component<OwnProps & StateProps & DispatchProps, OwnState> {
    private adyenContainerRef = React.createRef<HTMLDivElement>();
    private checkout: any = null;

    constructor(props: OwnProps & StateProps & DispatchProps) {
        super(props);

        this.state = {
        };
    }

    componentDidMount(): void {
        this.props.createPaymentSession();
    }

    componentDidUpdate(prevProps: Readonly<OwnProps & StateProps & DispatchProps>, prevState: Readonly<OwnState>, snapshot?: any): void {
        if (!prevProps.paymentSession && this.props.paymentSession) {
            this.initAdyenDropInComponent(this.props.paymentSession);
        }
    }

    handlePaymentFailed(): void {
        this.props.cardPaymentReject();
        this.props.createPaymentSession();
    }

    render(): JSX.Element {
        return (
            <div className='card-payment'>
                {this.props.isPaymentSessionLoading
                    ? <SofaLoader show={true} />
                    : this.renderAdyenComponent()
                }

            </div>
        );
    }

    renderAdyenComponent(): JSX.Element | null {
        if (!this.props.paymentSession) {
            return null;
        }

        return (<div ref={this.adyenContainerRef}></div>);
    }

    async initAdyenDropInComponent(paymentSession: PaymentSessionModel): Promise<void> {
        const configuration: CoreOptions = {
            environment: appConfig.adyen.environment,
            clientKey: appConfig.adyen.clientKey,
            analytics: {
                enabled: appConfig.adyen.isAnalyticEnabled,
            },
            session: {
                id: paymentSession.sessionId,
                sessionData: paymentSession.sessionData,
            },
            beforeSubmit: async (data, component, actions) => {
                return new Promise<void>(resolve => {
                    this.props.validateBeforePayment(
                        () => {
                            actions.resolve(data);
                            resolve();
                        },
                        () => {
                            actions.reject();
                            resolve();
                        }
                    );
                });
            },
            onPaymentCompleted: (result: OnPaymentCompletedData) => {
                if (paymentHelper.isSuccessfulPaymentResultCode(result.resultCode)) {
                    this.props.cardPaymentComplete(paymentSession.vendorTxCode);
                } else {
                    this.handlePaymentFailed();
                }

                scrollHelper.scrollToTopPage();
            },
            onError: () => {
                this.handlePaymentFailed();
            },
            paymentMethodsConfiguration: {
                card: {
                    hasHolderName: true,
                    holderNameRequired: true,
                },
            }
        };

        this.checkout = await AdyenCheckout(configuration);
        this.checkout.create('dropin').mount(this.adyenContainerRef.current);
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        paymentSession: state.paymentState.paymentSession,
        isPaymentSessionLoading: state.paymentState.isPaymentSessionLoading
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(
        dispatch,
        [
            createPaymentSession,
            cardPaymentReject,
            cardPaymentComplete,
            validateBeforePayment
        ]
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(CardPayment);